import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const NavClockBold = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12,21.5c-5.238,0-9.5-4.262-9.5-9.5S6.762,2.5,12,2.5s9.5,4.262,9.5,9.5S17.238,21.5,12,21.5z\n\t        M12,5.5c-3.584,0-6.5,2.916-6.5,6.5s2.916,6.5,6.5,6.5s6.5-2.916,6.5-6.5S15.584,5.5,12,5.5z" }),
    React.createElement("polygon", { points: "16.487,13.15 10.797,13.15 10.797,7.459 13.797,7.459 13.797,10.15 16.487,10.15" })), 'NavClockBold');
export default NavClockBold;
